module.exports = __webpack_public_path__ + "static/media/3H.dfb7b9c5.svg";